import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './PaymentMethod.css';
import { isWalletConnectConfigured } from '../utils/walletConnect';
import { isWeb3AuthConfigured } from '../utils/web3Auth';

const WALLETCONNECT_HIDDEN = true; // Set to false to show WalletConnect again

export default function PaymentMethod({ onSelect, selectedMethod, compact = false }) {
  const web3AuthAvailable = isWeb3AuthConfigured();
  const walletConnectAvailable = isWalletConnectConfigured();
  const defaultMethod = web3AuthAvailable ? 'web3auth' : (WALLETCONNECT_HIDDEN ? 'metamask' : (walletConnectAvailable ? 'walletconnect' : 'metamask'));
  const [method, setMethod] = useState(
    selectedMethod === 'walletconnect' ? defaultMethod : (selectedMethod || defaultMethod)
  );

  // When WalletConnect is hidden, ensure parent doesn't stay on walletconnect
  useEffect(() => {
    if (WALLETCONNECT_HIDDEN && selectedMethod === 'walletconnect' && onSelect) {
      onSelect(defaultMethod);
    }
  }, [WALLETCONNECT_HIDDEN, selectedMethod, defaultMethod, onSelect]);

  const handleChange = (e) => {
    const newMethod = e.target.value;
    setMethod(newMethod);
    if (onSelect) {
      onSelect(newMethod);
    }
  };

  return (
    <div className={`payment-method-container ${compact ? 'payment-method-compact' : ''}`}>
      {!compact && <h4 className="payment-method-title">Payment Method</h4>}
      <div className="payment-options">
        <label className={`payment-option ${method === 'web3auth' ? 'selected' : ''}`} style={{ opacity: web3AuthAvailable ? 1 : 0.6 }}>
          <input
            type="radio"
            name="paymentMethod"
            value="web3auth"
            disabled={!web3AuthAvailable}
            checked={method === 'web3auth'}
            onChange={handleChange}
            style={{ cursor: web3AuthAvailable ? 'pointer' : 'not-allowed' }}
          />
          <div className="payment-option-content">
            <div className="payment-option-icon">🔐</div>
            <div className="payment-option-info">
              <div className="payment-option-name">
                {web3AuthAvailable ? 'Email / Social Login (Web3Auth)' : 'Email / Social Login'}
                {!web3AuthAvailable && <span style={{ color: '#9e9e9e', fontSize: '0.85rem' }}> — Not configured</span>}
              </div>
              <div className="payment-option-desc">
                {web3AuthAvailable ? 'Sign in with email or social. No wallet install needed.' : 'Set REACT_APP_WEB3AUTH_CLIENT_ID to enable.'}
              </div>
            </div>
          </div>
        </label>

        {!WALLETCONNECT_HIDDEN && (
        <label className={`payment-option ${method === 'walletconnect' ? 'selected' : ''}`} style={{ opacity: walletConnectAvailable ? 1 : 0.6 }}>
          <input
            type="radio"
            name="paymentMethod"
            value="walletconnect"
            disabled={!walletConnectAvailable}
            checked={method === 'walletconnect'}
            onChange={handleChange}
            style={{ cursor: walletConnectAvailable ? 'pointer' : 'not-allowed' }}
          />
          <div className="payment-option-content">
            <div className="payment-option-icon">🔗</div>
            <div className="payment-option-info">
              <div className="payment-option-name">
                WalletConnect
                {!walletConnectAvailable && <span style={{ color: '#ffa726', fontSize: '0.85rem' }}> (Configure `REACT_APP_WALLETCONNECT_PROJECT_ID`)</span>}
              </div>
              <div className="payment-option-desc">Connect any mobile wallet via QR code.</div>
            </div>
          </div>
        </label>
        )}

        <label className={`payment-option ${method === 'metamask' ? 'selected' : ''}`}>
          <input
            type="radio"
            name="paymentMethod"
            value="metamask"
            checked={method === 'metamask'}
            onChange={handleChange}
          />
          <div className="payment-option-content">
            <div className="payment-option-icon">🦊</div>
            <div className="payment-option-info">
              <div className="payment-option-name">Browser wallet (MetaMask)</div>
              <div className="payment-option-desc">Use a wallet extension you already have installed</div>
            </div>
          </div>
        </label>

        {/* Native-token mode: keep UX simple. If you want an onramp later, we can add a "Buy ETH" link-out. */}

        {!compact && (
          <div className="metamask-guide-link">
            <Link to="/metamask-guide" className="guide-link-text">
              📖 Wallet setup help
            </Link>
          </div>
        )}
      </div>
      
    </div>
  );
}
